var map = {
	"./af.svg": "9e50",
	"./ar.svg": "d42c",
	"./cs.svg": "39ce",
	"./da.svg": "8af9",
	"./de.svg": "d08c",
	"./el.svg": "0237",
	"./en.svg": "8166",
	"./es.svg": "e6b5",
	"./fi.svg": "152d",
	"./fr.svg": "0977",
	"./hi.svg": "1925",
	"./id.svg": "aada",
	"./it.svg": "72bc",
	"./ja.svg": "54bc",
	"./kk.svg": "f172",
	"./ko.svg": "2ad7",
	"./mm.svg": "f401",
	"./ms.svg": "7bc6",
	"./nl.svg": "86bf",
	"./no.svg": "ea2a",
	"./pl.svg": "3e49",
	"./pt.svg": "d5e0",
	"./ru.svg": "105b",
	"./sv.svg": "35ef",
	"./th.svg": "7fe2",
	"./tl.svg": "71b9",
	"./tr.svg": "f188",
	"./uk.svg": "f69a",
	"./vi.svg": "4c03",
	"./zh-CN.svg": "1d74",
	"./zh-TW.svg": "f2c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "acc6";